import getMapRestaurants, {
  type GetMapRestaurantsParams,
} from '@discover-data/gql/getters/mapRestaurants';
import { isAbortError } from '@discover-data/stores/restaurant/utils/store/AbortError';

export type FetchRestaurantsParams = {
  variables: GetMapRestaurantsParams['variables'];
  setLoading: (loading: boolean) => void;
  abortSignal: AbortSignal;
};

export default async function fetchRestaurants(
  variables: GetMapRestaurantsParams['variables'],
  setLoading: (loading: boolean) => void,
  abortSignal: AbortSignal
) {
  function onAbort() {
    setLoading(false);
  }

  try {
    if (abortSignal.aborted) {
      return;
    }

    abortSignal.addEventListener('abort', onAbort);

    setLoading(true);

    const restaurants = await getMapRestaurants(variables, abortSignal);

    abortSignal.removeEventListener('abort', onAbort);

    if (abortSignal.aborted) {
      return [];
    }

    setLoading(false);

    return restaurants;
  } catch (error) {
    if (!isAbortError(error)) {
      setLoading(false);

      throw error;
    }
  }
}
